export default __webpack_public_path__ + "media/images/amenities/kettle-30d2da742e619c29c092ad2fa1b32634.jpeg";